import api_url from '../../libary/axios-home';

export const fetchChatById = async ({ queryKey }) => {
  const [_, id] = queryKey;
  const { data } = await api_url.get(`chats/appointment/${id}`);
  return data;
};
